import {RequestInfo} from "@repo/shared-core";

import {getChromeMessagePort} from "./extension-messaging.ts";

/**
 * Subscribe to events for receiving incoming messages.
 */
export function subscribeToIncomingMessages(
    handler: (event: MessageEvent) => void,
): () => void {
    // NOTE: In tests, regardless of the environment we're pretending to be,
    // we always use window.postMessage to send signals for tests.
    if (process.env.NODE_ENV === "test" || RequestInfo.isMobileApp) {
        window.addEventListener("message", handler);
        return () => {
            window.removeEventListener("message", handler);
        };
    }
    if (RequestInfo.isExtension) {
        getChromeMessagePort()?.onMessage.addListener(handler);

        return () => {
            getChromeMessagePort()?.onMessage.removeListener(handler);
        };
    }

    // If it's not a supported integration, we'll just return a no-op. We're
    // not subscribing to anything.
    return () => {};
}
